import $ from "jquery";
//Page single-agence, onglet horaires
$('.product-images__thumbnails-item').click(function(e) {
    e.preventDefault();
    var thumb_id = $(this).attr('href');

    $('.product-images__thumbnails-item').removeClass('current');
    $('.product-images__image-large').removeClass('current');

    $(this).addClass('current');
    $(thumb_id).addClass('current');
});

(function ($) {
    $(document).ready(function() {
        $('.product-images__image-large--image').colorbox({
            rel:'gal',
            maxHeight: "95%",
            maxWidth: "95%",
            current: "{current}/{total}"
            // iframe: true
        });
    })
})(jQuery);